import { SipSettingUpdateCallback } from 'data/template/template.types';
import { useDialedDigitExtractionServerFieldCreateNewNetworkInterface } from './useDialedDigitExtractionServerFieldCreateNewNetworkInterface';

// eslint-disable-next-line import/prefer-default-export
export function useSipSettingFieldCreateNew(
  handleFieldUpdate: SipSettingUpdateCallback,
): [SipSettingUpdateCallback] {

  const [
    handleFieldDeliveryFunctionNetworkInterface,
  ] = useDialedDigitExtractionServerFieldCreateNewNetworkInterface(handleFieldUpdate);

  const handleFieldCreateNew: SipSettingUpdateCallback = (param, formSectionName) => {
    const { name } = param;
    if (name === 'niid') {
      handleFieldDeliveryFunctionNetworkInterface(param, formSectionName);
    }
  };

  return [handleFieldCreateNew];
}
